import { connect } from 'react-redux';
import {
  getAddressSearchResults,
  getAddressBySuggestionCanNavigateBack,
  searchLoadingSelector,
  searchParam,
  getSuggestedAddressError,
} from 'redux/modules/address-suggestion/selectors';
import {
  searchAddresses,
  selectSuggestedAddress,
  navigateBackSuggestedAddress,
} from 'redux/modules/address-suggestion/actions';

import AddressSearch from 'components/AddressSearch/AddressSearch';

const ID = 'address-search';
const PLACEHOLDER = 'Start typing an address or postcode';

export const onSearchError = error => {
  if (error && error.status) {
    return { error: true };
  }
  throw error;
};

const mapStateToProps = state => ({
  canNavigateBack: getAddressBySuggestionCanNavigateBack(state),
  id: ID,
  heldValue: searchParam(state).searchTerm,
  loading: searchLoadingSelector(state),
  placeholder: PLACEHOLDER,
  searchItems: getAddressSearchResults(state),
  error: getSuggestedAddressError(state) !== null,
});

const mapDispatchToProps = (dispatch, props) => {
  const { existingValues, postSelect } = props;

  return {
    onChange: searchTerm =>
      dispatch(searchAddresses(searchTerm)).catch(error => onSearchError(error)),

    onSelect: suggestion =>
      dispatch(
        selectSuggestedAddress({
          ...suggestion,
          existingValues,
        }),
      )
        .then(() => {
          if (postSelect && !suggestion.extraData) {
            postSelect();
          }
        })
        .catch(error => onSearchError(error)),
    onNavigateBack: () => dispatch(navigateBackSuggestedAddress()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressSearch);
